var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import merge from 'lodash.merge';
import omit from 'lodash.omit';
import set from 'lodash.set';
export function convertValues(_a) {
    var _b = _a.converter, converter = _b === void 0 ? {} : _b, values = _a.values, key = _a.key;
    var keyAsString = key.toString();
    var valueAsKey = get(values, keyAsString);
    var valueFromValues = get(values, valueAsKey);
    var valueConverted = get(converter, valueAsKey);
    var result = valueConverted || valueFromValues || valueAsKey;
    if (Array.isArray(result) && converter) {
        return result.reduce(function (acc, value, index) {
            var _a;
            acc[index] = (_a = get(converter, value)) !== null && _a !== void 0 ? _a : value;
            return acc;
        }, []);
    }
    return result;
}
export function mapValues(_a) {
    var autoFormats = _a.autoFormats, autoPick = _a.autoPick, autoFormat = _a.autoFormat, values = _a.values, configMapper = _a.mapper, pick = _a.pick, _b = _a.converter, configConverter = _b === void 0 ? {} : _b;
    var _c = autoFormat || prepareAutoFormatConfig({ autoFormats: autoFormats, autoPick: autoPick, pick: pick, values: values }), autoConverter = _c.converter, _d = _c.mapper, autoMapper = _d === void 0 ? {} : _d;
    var mapper = configMapper || autoMapper;
    var converter = merge({}, configConverter, autoConverter);
    if (isEmpty(values) || (isEmpty(mapper) && isEmpty(pick)))
        return {};
    if (pick)
        return { picked: convertValues({ converter: converter, values: values, key: pick }) };
    return Object.keys(mapper).reduce(function (acc, key) {
        var mapperKey = mapper[key].toString();
        // avoid creating nested attributes for attributes name using brackets
        if (mapperKey.match(/.*\[.*\]/)) {
            acc[mapperKey] = convertValues({ converter: converter, values: values, key: key });
        }
        else {
            set(acc, mapperKey, convertValues({ converter: converter, values: values, key: key }));
        }
        return acc;
    }, {});
}
export function prepareAutoFormatConfig(_a) {
    var _b = _a.autoFormats, autoFormats = _b === void 0 ? {} : _b, _c = _a.values, values = _c === void 0 ? {} : _c, _d = _a.pick, pick = _d === void 0 ? '' : _d, autoPick = _a.autoPick;
    var autoFormatPick = autoPick || pick;
    var attrKey = get(values, autoFormatPick, 'not_found');
    var fallbackConfig = get(autoFormats, autoFormatPick, {});
    return get(autoFormats, attrKey, fallbackConfig);
}
export function prepareFormatConfig(_a) {
    var format = _a.format, mappedValues = _a.mappedValues, props = __rest(_a, ["format", "mappedValues"]);
    return merge({}, format, omit(props, ['components', 'data-design']), mappedValues);
}
